import React from 'react';
import styled, { keyframes } from 'styled-components';
import * as Collapsible from '@radix-ui/react-collapsible';
import { CollapsibleContentProps } from '@radix-ui/react-collapsible';

const open = keyframes`
    from {
        height: 0;
    }
    to {
        height: var(--radix-collapsible-content-height);
    }
`;

const close = keyframes`
    from {
        height: var(--radix-collapsible-content-height);
    }

    to {
        height: 0;
    }
`;

const CollapsibleContent = styled(Collapsible.Content)<CollapsibleContentProps & { overflow: 'hidden' | 'visible' }>`
  &[data-state='open'] {
    animation: ${open} 300ms ease-out;
    overflow: ${props => props.overflow};
  }

  &[data-state='closed'] {
    animation: ${close} 300ms ease-out;
    overflow: ${props => props.overflow};
  }
`;
const Collapse = ({
  children,
  isOpen,
  forceMount,
  style,
}: {
  style?: React.CSSProperties;
  children?: React.ReactNode;
  isOpen?: boolean;
  forceMount?: true | undefined;
}) => {
  // overflow should be 'hidden' during animation and 'visible' otherwise (to allow child components to overflow if needed - for example drop-downs)
  const [overflow, setOverflow] = React.useState<'visible' | 'hidden'>('hidden');
  return (
    <Collapsible.Root
      style={style}
      onAnimationStart={() => !isOpen && setOverflow('hidden')}
      onAnimationEnd={() => isOpen && setOverflow('visible')}
      open={isOpen}
    >
      <CollapsibleContent forceMount={forceMount} style={style} overflow={overflow}>
        {children}
      </CollapsibleContent>
    </Collapsible.Root>
  );
};

export default Collapse;
